import { ArrowRight } from "@similarweb/icons";
import { colorsPalettes } from "@similarweb/styles";

import { OnboardingAgentHeaderAiSparkles } from "app/components/onboarding-agent/OnboardingAgentPanel/OnboardingAgentHeaderAiSparkles";
import { translate } from "app/filters/i18nFilter";

import { quickSearchDataAutomation } from "../dataAutomation";
import {
    QUICK_SEARCH_BOT_STRIP_DEFAULT,
    QUICK_SEARCH_BOT_STRIP_WITH_QUERY,
} from "../texts";
import { BotStripLeading, BotStripText, BotStripWrapper } from "./styles";

type QuickSearchBotStripProps = {
    query: string;
    onClick: (query: string) => void;
};

export const QuickSearchBotStrip = ({ query, onClick }: QuickSearchBotStripProps) => {
    const trimmedQuery = query.trim();
    const text = trimmedQuery
        ? translate(
              QUICK_SEARCH_BOT_STRIP_WITH_QUERY,
              { query: trimmedQuery },
              `Ask Similarweb Assistant about "${trimmedQuery}"`,
          )
        : translate(
              QUICK_SEARCH_BOT_STRIP_DEFAULT,
              {},
              "Not sure where to start? Ask Similarweb Assistant",
          );

    const handleClick = (): void => {
        onClick(trimmedQuery);
    };

    return (
        <BotStripWrapper
            onClick={handleClick}
            onKeyDown={(e) => {
                if (e.key === "Enter" || e.key === " ") {
                    e.preventDefault();
                    handleClick();
                }
            }}
            data-automation={quickSearchDataAutomation.botStrip}
            role="button"
            tabIndex={0}
        >
            <BotStripLeading>
                <OnboardingAgentHeaderAiSparkles />
                <BotStripText dangerouslySetInnerHTML={{ __html: text }} />
            </BotStripLeading>
            <ArrowRight
                size={16}
                color={colorsPalettes.carbon[300]}
            />
        </BotStripWrapper>
    );
};
